import React from 'react';
import styled from 'styled-components';
import LinkButton from '../components/LinkButton';

function Modal({
  children,
  ...props
}) {
  return (
    <Overlay>
      <Container {...props}>{children}</Container>
    </Overlay>
  );
}

export default Modal;

const Container = styled.div`
  z-index: 2;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 3rem;
  width: 30rem;
  background-color: #fff;
  border-radius: .125rem;
  box-shadow: 0 .0625rem rgba(0,0,0,.2);
`;

const Overlay = styled.div`
  // z-index: 99; // Same as the Header
  z-index: 109; // Same as the TabBar
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,.7);
`;

Modal.Title = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
`;

Modal.Body = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

Modal.Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    margin-right: .5rem;

    &:last-child {
      margin-right: 0;
    }
  }

  ${LinkButton} {
    margin-top: 1.75rem;
  }
`;
